import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { Injectable } from '@angular/core';
import { FcpDialogComponent } from './fcp-dialog.component';
import { ModalConfig } from './modal-config';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FcpModalService {
    public modalList: ModalConfig[] = [];
    private static instance: FcpModalService;

    constructor(private dialog: Dialog) {
        if (FcpModalService.instance) {
            return FcpModalService.instance;
        }
        FcpModalService.instance = this;
    }

    add(config: ModalConfig) {
        this.modalList.push(config);
    }

    update(id: string, newConfig: ModalConfig) {
        const config = this.modalList.find((modal) => modal.id === id);
        const modifiedConfig = { ...config, ...newConfig };
        this.modalList = this.modalList.map((modal) => (modal.id === id ? modifiedConfig : modal));
    }

    open(id: string, newConfig?: ModalConfig): DialogRef {
        if (newConfig) {
            this.update(id, newConfig);
        }
        const config = this.modalList.find((modal) => modal.id === id);
        if (!config) throw new Error(`Modal with id ${id} not found`);
        return this.dialog.open(FcpDialogComponent, config);
    }

    close(id: string) {
        const dialogRef = this.dialog.openDialogs.find((dialog) => dialog.id === id);
        if (!dialogRef) throw new Error(`Dialog with id ${id} not found`);
        dialogRef.close();
    }

    isModalOpen(id: string) {
        return !!this.dialog.getDialogById(id);
    }

    onClosed(id: string): Observable<any> {
        const dialogRef = this.dialog.getDialogById(id);
        if (!dialogRef) return;
        return dialogRef.closed;
    }

    remove(id: string) {
        this.modalList = this.modalList.filter((modal) => modal.id !== id);
    }

    removeAll() {
        this.modalList = [];
    }
}
